import { ActionTypes as e } from "./dynamicFilters.types.js";
const p = (t) => ({
  type: e.RESET,
  payload: t
}), o = (t) => ({
  type: e.UPDATE_SELECTABLE_CARD,
  payload: t
}), A = (t) => ({
  type: e.UPDATE_SELECTABLE_RADIO_CARD,
  payload: t
}), T = (t) => ({
  type: e.UPDATE_RADIO,
  payload: t
}), a = (t) => ({
  type: e.UPDATE_FILTERS,
  payload: t
}), s = (t) => ({
  type: e.RESET_FILTER,
  payload: t
});
export {
  p as reset,
  s as resetFilter,
  a as updateFilters,
  T as updateRadio,
  o as updateSelectableCard,
  A as updateSelectableRadioCard
};
